import { useContext } from 'react';
import { useSlate } from 'slate-react';
import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';
import { TagContext } from 'app/state/contexts/TagContext';
import { removeExclude } from 'app/slate/extensions/tag/utils/exclusion';

export const ExcludePanel = () => {
  const editor = useSlate();
  const { selectedExcludePath, setSelectedExcludePath } = useContext(TagContext) as any;

  if (!selectedExcludePath) return null;

  const handleRemove = () => {
    removeExclude(editor, selectedExcludePath);
    setSelectedExcludePath(null);
  };

  return (
    <section className="p-3 w-100">
      <Typography variant="body-7" fontWeight="light">
        {i18n('tag.exclude.panel.description')}
      </Typography>
      <div className="mt-2">
        <button className="btn btn-secondary" onClick={handleRemove}>
          {i18n('tag.exclude.remove')}
        </button>
        <button className="btn btn-link" onClick={() => setSelectedExcludePath(null)}>
          {i18n('common.cancel')}
        </button>
      </div>
    </section>
  );
};
